import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Fossils Collection';
moduleConfig.singleItemTitle = 'Collection Fossil';
//moduleConfig.url = 'fossils?type=Saleable';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Enable Selected",
        value: "enabled"
    },
    {
        displayName: "Disable Selected",
        value: "disabled"
    }
];


export default moduleConfig;